import WorkLog from "../../models/WorkLog";
import Position from "../../models/Position";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import BeachAccessIcon from '@mui/icons-material/BeachAccess';

interface QuickEditRowProps {
  instance: WorkLog;
  quickEditWorkLog?: WorkLog;
  isEditingRow: (instance: WorkLog) => boolean;
  handleOnQuickEditSave: (workLog: WorkLog, fromEnterKey?: boolean, dayOff?: boolean) => void;
  setQuickEditWorkLog: (workLog: WorkLog | null) => void;
  currPosition?: Position | null;
  setShouldFocus: (focus: boolean) => void;
  setFechUpdate: (fetch: boolean) => void;
}

export const QuickEditRow = ({
  instance,
  quickEditWorkLog,
  isEditingRow,
  handleOnQuickEditSave,
  setQuickEditWorkLog,
  currPosition,
  setShouldFocus,
  setFechUpdate,
}: QuickEditRowProps) => {
  const handleEditAddClick = () => {
    setQuickEditWorkLog({
      ...instance,
      hours: currPosition ? currPosition.externalHours : 8,
      internalHours: currPosition ? currPosition.internalHours : 8,
    });
    setShouldFocus(true);
  };

  const handleOnCancel = () => {
    setQuickEditWorkLog(null);
    setFechUpdate(true);
  };

  return (
    <div>
      {isEditingRow(instance) ? (
        <>
          <CheckIcon
            tabIndex={0}
            onClick={() => {
              handleOnQuickEditSave(quickEditWorkLog!);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                e.stopPropagation();
                handleOnQuickEditSave(quickEditWorkLog!, true);
              }
            }}
          ></CheckIcon>
          <BeachAccessIcon
            tabIndex={0}
            onClick={() => {
              handleOnQuickEditSave(quickEditWorkLog!, false, true);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                e.stopPropagation();
                handleOnQuickEditSave(quickEditWorkLog!, true, true);
              }
            }}
          />
          <ClearIcon
            tabIndex={0}
            onClick={handleOnCancel}
          ></ClearIcon>
        </>
      ) : (
        <>
          {instance.externalId ? (
            <EditIcon tabIndex={0} onClick={handleEditAddClick} />
          ) : (
            <AddIcon tabIndex={0} onClick={handleEditAddClick} />
          )}
        </>
      )}
    </div>
  );
};
